<template>
  <div class="multi-bg py-4">
    <section class="margin-t-20 stories-section d-lg-none d-block">
      <div class="un-title-default">
        <div class="text">
          <h2 class="title-gradient">Category List</h2>
          <p>See all category list</p>
        </div>
        <div class="un-block-right">
          <router-link to="/category" class="icon-back" aria-label="iconBtn">
            <i class="ri-arrow-drop-right-line"></i>
          </router-link>
        </div>
      </div>
      <!-- DISPLAY STRORIES -->
      <div class="display-stories margin-t-20">
        <!-- SWIPER -->
        <div
          class="
            swiper
            myStories
            swiper-initialized
            swiper-horizontal
            swiper-free-mode
            swiper-android
            swiper-backface-hidden
          "
        >
          <div
            class="
              swiper-wrapper
              wrapper-stories
              stories
              user-icon
              carousel
              snapgram
            "
            id="stories"
            style="
              transform: translate3d(0px, 0px, 0px);
              transition-duration: 0ms;
              display: flex;
              flex-direction: row;
              overflow-x: auto;
              fler-wrap: nowrap;
            "
          >
            <!-- HERE -> ITEMS -> AUTOMATICALLY BY JAVASCRIPT -->
            <div
              class="story swiper-slide swiper-slide-active"
              v-for="(category, index) in categoryLists"
              :key="index"
              :data-id="category.id"
              :data-photo="category.logo_url"
              role="group"
              aria-label="1 / 7"
            >
              <router-link
                class="item-link"
                :to="'/category-choose/' + category.slug"
              >
                <span class="item-preview">
                  <img
                    lazy="eager"
                    :src="
                      !category?.logo_url?.startsWith('/images')
                        ? 'https://api-dapps.dinowallet.org/images/category/' +
                          category?.logo_url
                        : category?.logo_url
                    "
                    @error="() => (category.logo_url = '/images/no-images.png')"
                  />
                </span>
                <span
                  class="info"
                  itemprop="author"
                  itemscope=""
                  itemtype="http://schema.org/Person"
                >
                  <strong class="name" itemprop="name">{{
                    category.name
                  }}</strong>
                </span>
              </router-link>
            </div>
          </div>
          <span
            class="swiper-notification"
            aria-live="assertive"
            aria-atomic="true"
          ></span>
        </div>
      </div>
    </section>

    <div
      class="
        unList-creatores
        collection-creatores
        container
        py-3
        d-lg-block d-none
      "
    >
      <div class="content-list-creatores">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h2 class="fw-bolder title-gradient">Popular Category</h2>
            <p>Sort by Dapps Count already listed</p>
          </div>
          <router-link
            to="/category"
            class="
              btn btn-dark
              rounded-pill
              px-4
              d-flex
              justify-content-between
              gap-2
              align-items-center
            "
            aria-label="iconBtn"
          >
            <span>View All</span> <i class="ri-arrow-right-line"></i>
          </router-link>
        </div>
        <ul class="nav row col-12 align-items-center w-100 m-0">
          <li
            class="nav-item col-4"
            v-for="(category, index) in categoryLists"
            :key="index"
          >
            <div
              class="nav-link border-bottom-0 visited"
              style="padding: 20px 0px !important"
            >
              <div class="collection-img">
                <picture
                  class="
                    img-cot
                    border-gradient
                    h-auto
                    border border-gray
                    bg-light
                    shadow-sm
                    p-2
                  "
                  v-for="(products, index) in category.limit_products"
                  :key="index"
                >
                  <router-link
                    :to="'/dapps-detail/' + products.slug"
                    :aria-label="products.slug"
                  >
                    <source
                      :srcset="
                        !products.icon_url?.startsWith('/images')
                          ? 'https://api-dapps.dinowallet.org/images/icon-dapps/' +
                            products?.icon_url
                          : products?.icon_url
                      "
                      width="59.6"
                      height="59.6"
                      type="image/webp"
                      class="img-fluid rounded-circle"
                      @error="
                        () => (products.icon_url = '/images/no-images.png')
                      "
                    />
                    <img
                      class="img-fluid rounded-circle"
                      :src="
                        !products.icon_url?.startsWith('/images')
                          ? 'https://api-dapps.dinowallet.org/images/icon-dapps/' +
                            products?.icon_url
                          : products?.icon_url
                      "
                      @error="
                        () => (products.icon_url = '/images/no-images.png')
                      "
                      width="59.6"
                      height="59.6"
                      alt=""
                    />
                  </router-link>
                </picture>
              </div>
              <router-link
                to="/"
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  border border-gray
                  shadow-sm
                  p-3
                  bg-light
                  rounded-10
                  text-decoration-none
                "
              >
                <div class="item-user-img">
                  <div class="wrapper-image">
                    <picture>
                      <source
                        :srcset="
                          !category.logo_url?.startsWith('/images')
                            ? 'https://api-dapps.dinowallet.org/images/category/' +
                              category?.logo_url
                            : category?.logo_url
                        "
                        @error="
                          () => (category.logo_url = '/images/no-images.png')
                        "
                        type="image/webp"
                      />
                      <img
                        class="avt-img"
                        :src="
                          !category.logo_url?.startsWith('/images')
                            ? 'https://api-dapps.dinowallet.org/images/category/' +
                              category?.logo_url
                            : category?.logo_url
                        "
                        @error="
                          () => (category.logo_url = '/images/no-images.png')
                        "
                        alt=""
                      />
                    </picture>
                    <div class="icon">
                      <i class="ri-checkbox-circle-fill"></i>
                    </div>
                  </div>
                  <div class="txt-user">
                    <div>{{ category.name }}</div>
                    <!-- <p>
                      18.3 ETH <span class="price-eth size-11">($13,05)</span>
                    </p> -->
                  </div>
                </div>
                <div class="other-option">
                  <div
                    class="
                      color-text
                      rounded-pill
                      bg-snow
                      btn-xs-size
                      text-white
                    "
                  >
                    {{ category.products_count }} Dapps
                  </div>
                </div>
              </router-link>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CategoriesCircle",
  data() {
    return {
      categoryLists: [],
    };
  },
  mounted() {
    let fontAwesome = document.createElement("script");
    fontAwesome.setAttribute("src", "/vendors/swiper/swiper-bundle.min.js");
    document.head.appendChild(fontAwesome);
    this.getCategoryList();
  },
  methods: {
    async getCategoryList() {
      try {
        await axios
          .get(process.env.VUE_APP_API + "api/category/getnew")
          .then((response) => (this.categoryLists = response.data.data));
      } catch (e) {
        console.log("Caught Error");
      }
    },
  },
};
</script>

<style scoped>
.collection-creatores
  .content-list-creatores
  .nav-item:first-of-type
  .nav-link {
  padding: 20px !important;
}

.multi-bg {
  height: auto;
  display: block;
  background-color: #14151c;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='143' height='143' viewBox='0 0 143 143' fill='none'%3E%3Cg clip-path='url(%23clip0_130_10)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M65.498 61.1385C68.3397 61.2467 67.6802 61.7995 69.538 59.4798C70.2341 58.611 70.7225 58.4384 71.188 57.9211C73.4102 55.454 69.2479 56.8926 75.3765 52.8296C77.6422 51.3276 75.3991 53.4309 79.11 50.5733C80.1269 49.7902 79.9736 50.2482 80.8819 49.2705C81.7757 48.3087 82.7664 46.2613 83.9264 45.5989C84.5696 45.232 85.6516 45.1157 86.0676 44.8899C89.3035 43.1325 87.5679 35.5365 95.2836 34.6473C97.4918 34.3925 97.5325 35.3791 99.5454 33.5375L104.2 28.3278C106.308 25.2274 106.092 28.3057 107.408 25.5149C108.14 23.9612 107.71 25.1086 108.731 23.7784C110.41 21.59 109.701 21.8954 112.189 20.9203C114.389 20.058 117.395 18.5329 119.128 16.0103C117.708 16.0974 117.61 16.7428 116.498 17.6607C114.663 19.1742 112.468 18.6515 110.801 20.3231C105.856 25.2797 108.742 20.0107 102.867 25.4555C96.2673 31.5738 94.148 29.4321 91.8396 31.5145C90.9149 32.3489 91.6027 31.9504 90.4996 32.6009C88.6987 33.6629 88.5742 34.0833 86.9438 35.8175C85.3155 37.55 83.8197 35.5552 81.1115 38.0971C76.2294 42.679 79.1434 40.0971 77.4562 43.2968C76.0513 43.6068 77.0415 43.4574 75.4187 43.5793C73.0871 43.7546 75.5905 43.9791 70.8265 46.1691C69.6269 46.7205 69.0904 47.5308 67.8126 48.2414C65.9176 49.2955 66.3413 48.9713 65.6957 51.6378C65.0647 51.725 62.835 52.1669 62.1886 52.6231C62.0136 52.7466 60.7302 55.0724 60.3943 55.6697C58.5132 59.0182 58.4408 59.4275 54.391 59.3258C51.5036 66.135 51.9097 63.7607 50.2583 65.0946C47.3681 67.4298 47.2631 70.5979 46.9277 71.5159C45.7698 71.6989 44.6517 71.8713 43.7688 72.8348C39.3943 77.6068 43.0912 76.2511 40.3467 78.9383C39.284 79.9788 38.7097 79.6347 37.7727 81.2803C36.2027 84.0376 34.8221 82.833 32.9431 86.9132C32.0159 88.9263 32.7641 89.5043 31.8106 91.0658C31.0451 92.319 30.0525 92.0732 29.4111 93.5315C28.6449 95.2748 29.543 95.4093 28.3267 97.8467C27.3146 99.8735 26.89 99.024 25.6041 99.8916C25.1984 100.165 21.3946 105.422 21.2316 105.828C20.2307 108.318 21.162 107.798 19.3941 109.833C18.3117 111.079 18.2593 112.282 17.9711 113.824C17.0635 118.678 16.358 116.928 14.6215 120.617C16.2289 119.878 17.4502 117.735 18.1763 116.128C20.3606 111.294 20.5132 113.635 21.0259 111.354C21.9422 107.279 22.1458 109.495 24.1783 106.917C28.6479 101.249 23.8355 105.176 28.8056 100.444C31.9784 97.4232 29.938 95.1089 35.1659 90.9398C36.32 90.0193 35.9869 89.8769 36.9327 89.0111C37.4423 88.5449 40.3781 87.1158 41.1364 86.7649C41.323 84.1124 40.7558 84.654 42.6793 82.0608C44.0351 80.233 44.5703 80.245 46.2908 79.6595C47.4286 77.0982 46.8667 75.7976 49.2081 75.1465C53.4749 73.9599 52.3355 75.5362 56.6165 69.9323C58.7916 67.0848 57.6357 68.4678 60.1518 67.0121C60.8568 65.0898 60.2693 63.375 62.014 62.8674C64.54 62.1327 63.0097 64.2006 65.498 61.1385V61.1385ZM112.331 40.6476C113.692 40.6829 112.505 40.872 113.705 40.0465C116.32 38.2471 116.09 39.1681 117.369 37.7791C119.03 35.9749 120.835 36.2137 121.664 33.585C120.383 34.1617 119.305 35.2623 118.077 35.8369C116.102 36.7611 116.225 36.0524 114.547 37.9161C114.023 38.4977 114.263 38.3849 113.581 38.7165C104.299 43.2386 107.111 44.2048 104.105 45.7141C102.343 46.5995 102.4 45.8967 100.467 47.6192C99.1538 48.7883 97.39 50.0116 95.9782 50.474C94.0108 51.1185 94.9556 51.5255 93.68 52.4005C92.6653 53.0961 93.0655 52.2509 91.7589 53.3983C90.3675 54.6208 88.5849 57.7775 87.1083 58.2238C84.9034 58.8908 86.3908 57.3116 83.0964 59.3321C80.1622 61.1318 81.8873 61.0382 80.6505 63.6159L77.7171 67.5741L72.072 70.2785C71.0029 70.3294 71.2221 69.701 70.0519 70.5759C69.2683 71.162 69.6677 71.6787 69.2774 72.6762C68.6351 74.3167 68.8175 73.1908 67.8185 74.5011L69.0373 75.7643C69.1017 75.7064 69.1861 75.8772 69.2513 75.9438C66.5726 78.9957 65.3005 77.8825 64.6465 80.062C64.3421 81.0761 64.3972 82.2941 63.4144 83.457C62.3812 84.6792 61.9075 83.8912 60.7688 84.5041C60.4313 85.1307 60.1089 86.5261 59.0665 87.7578C58.0698 88.9351 57.5675 88.4347 56.4093 89.3991C54.5716 90.9297 53.958 94.2958 52.9548 95.6525C52.359 96.4584 51.5999 96.4821 50.5144 98.3738C49.362 100.382 49.5664 99.4845 48.3501 100.957C45.0893 104.901 43.9548 103.33 43.6066 106.793C43.4225 108.625 43.1703 107.089 42.7917 108.831C42.5513 109.937 43.5236 108.807 42.4245 110.295C41.5617 111.464 38.1445 113.171 36.5468 115.968C35.8199 117.241 35.4959 118.713 34.8322 119.988L28.9999 128.9C29.2309 128.83 31.1373 126.706 31.6387 126.183C33.1986 124.554 32.9462 123.844 34.0771 122.415C34.4841 121.9 35.0737 121.592 35.5296 121.007C35.9565 120.459 36.3265 119.769 36.7877 119.169C38.1349 117.418 37.5364 116.689 39.2388 115.903C40.3624 115.384 40.5584 115.704 42.2209 113.078C43.4522 111.133 43.076 111.047 44.8975 109.892C47.1196 108.484 46.171 108.657 47.6264 106.517C48.2845 105.549 48.1806 106.177 48.8494 104.916C49.444 103.796 48.7831 104.055 49.9058 103.198C51.4111 101.891 51.0123 103.787 52.4003 102.237C53.1803 101.366 52.9461 100.682 54.167 99.6821C57.1369 97.2497 54.9601 96.3728 57.9792 96.4021L58.5808 96.4292C59.5596 94.5068 61.2159 91.927 62.8996 91.1786C65.909 89.8407 62.7293 92.1906 68.3142 88.2536C68.6477 86.0345 67.3806 87.9643 68.5898 86.3121C69.3523 85.2701 68.9982 85.9962 69.408 85.845C72.3813 84.75 70.069 85.1329 73.025 84.4727C73.5133 82.8543 73.4729 83.7996 73.6277 82.0873L74.2479 80.1356C74.4399 78.5309 73.4427 80.9735 74.364 78.8C75.8095 77.755 75.61 78.5573 76.9098 77.5402C77.9223 76.7478 77.9704 76.0904 78.7812 75.197C79.2101 74.7237 80.4272 74.0594 81.0326 73.858C82.8561 73.2519 82.4672 73.8951 83.9247 73.9474L85.3141 72.1001C86.2432 71.1151 88.1903 71.0246 88.979 68.3682C89.3362 67.1653 88.9275 67.5714 89.4703 66.4652C93.1771 58.9111 91.6485 60.5306 95.2677 60.225C95.9416 59.1353 96.1531 58.8548 97.2266 58.0597C100.269 55.8048 100.658 53.8076 101.43 51.2375C102.373 51.0929 105.578 49.6742 106.276 49.0941C108.129 47.5562 108.315 45.8402 109.507 43.3386C111.452 42.8064 111.032 43.4982 112.823 42.3229C112.817 41.7962 112.878 42.125 112.66 41.3998L112.331 40.6476V40.6476ZM60.4042 36.4154C60.7396 36.4342 61.4408 37.0299 62.2514 36.2107C64.1823 34.2591 62.099 33.1097 66.938 31.5213C69.7551 30.5964 71.564 27.5003 71.8171 27.2465C72.8368 26.2253 72.3065 27.1311 73.4674 26.1676C74.8198 25.0455 75.0114 23.2232 76.3183 22.1275C76.3458 22.1046 83.5975 18.2188 86.7001 15.1532C85.0095 15.3364 84.4946 16.5248 82.128 16.9988C79.0049 17.6245 78.4676 20.2001 74.3979 22.5861L73.3024 23.0662C71.3965 23.7043 70.7298 25.3733 68.6653 26.8006C67.9679 27.2831 67.1763 27.3505 66.4235 27.7004C64.6006 28.5476 65.6155 29.4151 62.6419 30.4234L60.5576 31.6707C54.2822 36.1126 58.5988 30.0815 54.9666 36.2844C48.4953 37.0278 54.0358 39.21 48.7925 39.5552L47.8868 42.6447C45.4 43.4224 46.8635 43.3344 45.1329 44.6101C44.5257 45.0579 42.7606 45.6821 42.367 46.05C41.4462 46.91 42.2213 47.7177 41.1103 49.4936L38.7866 52.5155C36.9918 52.8318 37.3431 52.7963 36.5262 53.9913C34.8483 56.4463 31.4065 55.965 32.7623 61.1219L29.1053 63.524C26.7101 66.0402 26.5863 71.1704 25.054 72.7536C24.5184 73.3068 23.8938 73.5771 23.4379 74.4098L22.7237 76.2649C22.6827 76.3377 22.5663 76.56 22.5206 76.6439L20.7944 80.0829C19.7751 82.8153 19.024 81.6875 18.264 84.2252C17.5085 86.7477 14.0201 92.3899 14.2985 93.5908C16.2415 92.3665 19.6545 84.7463 20.607 83.5391C23.2531 80.1843 24.744 78.2089 26.6002 74.4774C28.6189 70.4189 29.2308 72.9536 30.3787 70.6506C30.969 69.4663 30.7823 68.5023 31.4753 67.8025C32.1044 67.1676 32.9758 67.1752 33.611 66.7279C34.8894 65.8278 34.2202 65.591 35.6211 64.7581L36.7107 64.1661C39.3467 62.2625 38.5679 60.1982 39.3909 58.0061C41.0285 57.7627 39.9249 58.0915 41.6171 57.2041C43.8427 56.0378 43.1473 56.7137 44.2703 54.6132C46.4762 50.4879 46.0992 50.8765 48.8218 50.0867C49.1156 49.4647 49.2546 48.8414 49.4184 48.4467L49.8106 47.649C50.7849 46.5006 50.2967 47.8355 51.809 46.7723C53.0343 45.9108 53.3416 43.9321 54.1864 42.2007L54.9133 42.0213C54.9745 42.0009 55.0759 41.9716 55.1379 41.9479L56.1492 41.3654C57.6402 40.2896 59.1317 38.2304 60.4042 36.4154V36.4154ZM119.893 61.1139C120.989 59.5557 119.775 59.6429 121.777 58.3565C124.118 56.8511 122.305 57.8987 123.398 56.2385C124.469 54.6121 127.018 54.9088 127.834 52.2424C126.933 52.7347 126.38 53.2491 125.412 53.7261C121.454 55.6763 124.898 54.6305 121.009 56.8214L116.471 60.1667C114.9 61.2575 115.504 60.0352 114.316 61.7798C112.601 64.3004 111.347 63.5816 110.075 65.2943C108.947 66.813 109.497 66.5105 107.881 67.3176C105.006 68.7544 105.862 68.878 104.586 69.9386C101.474 72.5236 102.905 71.9689 101.753 72.9395C101.247 73.3653 101.527 73.0904 101.105 73.2736C99.1599 74.1174 101.637 72.8268 100.43 73.4983C99.9027 73.7913 99.8082 73.9273 99.3629 74.6666C98.5472 76.0213 98.8171 76.7443 97.6151 77.1191C95.9926 77.6252 95.9988 76.454 94.7471 77.2785C93.8337 77.8801 94.0759 78.4025 92.7435 79.2215C89.6241 81.1391 92.0426 79.4866 89.3657 83.7637C87.916 86.08 88.7446 84.7161 87.4284 85.916L85.6696 87.8769C84.6655 88.9352 85.8785 89.052 84.8645 91.0179C84.43 91.8603 83.3705 92.728 82.9235 93.2633C81.684 94.7469 82.275 94.9374 81.4995 96.405L77.6063 101.025C77.1873 101.619 76.6164 103.505 76.2337 104.36C74.9603 107.203 74.0994 106.966 72.5499 108.851C68.065 114.306 71.248 110.904 69.292 113.751C68.4929 114.914 66.3508 117.43 66.5453 118.847C67.9421 117.795 68.5745 115.572 69.8164 114.321C71.3361 112.79 72.6589 113.183 74.0567 111.183C73.5979 109.712 72.5206 109.528 74.6907 108.342C76.4992 107.352 75.7946 108.211 77.0924 106.16C80.2981 101.092 77.8498 102.424 81.485 101.413C82.6069 98.0651 82.7388 98.2947 85.665 97.2362C87.0701 96.7279 88.9097 93.6306 88.9325 93.5673C89.4062 92.2556 88.9441 93.7368 88.9051 92.1465C91.7526 90.0328 90.1531 90.9678 92.05 88.2485C93.726 88.1318 92.6602 88.6452 95.0732 87.8862C97.4111 87.1507 97.9157 87.4378 98.9326 85.9588C100.395 83.8319 98.8229 83.8683 99.7286 81.0998L101.179 80.5837C101.774 80.4122 101.9 80.3478 102.681 80.2389L103.438 78.0161L105.599 77.6675C106.192 76.483 106.966 73.8571 107.784 73.1629C108.432 72.6126 108.355 73.0284 109.375 72.0261C111.907 69.5392 109.844 66.7547 115.577 65.0106C116.911 61.2489 116.389 61.4663 119.893 61.1139V61.1139Z' fill='%2315813C'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_130_10'%3E%3Crect width='143' height='143' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom center, 50%, 50%;
}
</style>
